import React, { ReactElement } from 'react';

export interface RoomPartCombinationProps {
    roomParts: string[];
    roomColor?: string;
    combinationParts: string[];
}

export default function RoomPartCombination({
    roomParts,
    roomColor,
    combinationParts,
}: RoomPartCombinationProps): ReactElement {
    return (
        <div className={'room-part-combination'} aria-hidden="true">
            {roomParts.map(part => {
                const isSelected = combinationParts.includes(part);
                return (
                    <div
                        style={isSelected && roomColor ? { backgroundColor: roomColor } : {}}
                        className={'room-part' + (isSelected ? ' -selected' : '')}
                        key={part}
                    ></div>
                );
            })}
        </div>
    );
}
